import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["closingDay", "paymentMonthOffset", "paymentDay", "preview"]

  connect() {
    this.updatePreview()
  }

  updatePreview() {
    if (!this.hasPreviewTarget) return

    const closingDay = parseInt(this.closingDayTarget.value)
    const paymentMonthOffset = parseInt(this.paymentMonthOffsetTarget.value)
    const paymentDay = parseInt(this.paymentDayTarget.value)

    const closingText = closingDay === 99 ? '毎月末' : `毎月${closingDay}日`
    const offsetText = paymentMonthOffset === 0 ? '当月' : '翌月'
    const paymentText = paymentDay === 99 ? '末' : `${paymentDay}日`

    const previewText = `${closingText}締め${offsetText}${paymentText}払い`

    // 当月払いで支払日が締め日以前の場合の警告
    if (paymentMonthOffset === 0 && paymentDay !== 99 && closingDay !== 99 && paymentDay <= closingDay) {
      this.previewTarget.innerHTML = `
        <span class="text-red-600">${previewText}</span><br>
        <span class="text-xs text-red-500">⚠️ 支払日は締め日より後の日付を選択してください</span>
      `
    } else {
      this.previewTarget.innerHTML = `<span class="text-gray-900">${previewText}</span>`
    }
  }
}
